import { Link } from "react-router";
import { Pages } from "../../../utils";
import { AccessOfferLink } from "./AccessOfferLink";

const ENHANCIFY_PROMO_URL =
  "https://www.enhancify.com/home-design-guild-2-promo";

export const BottomCtaSection = () => {
  return (
    <section id="access" className="bottom-cta">
      <p className="eyebrow">Take the next step</p>
      <h2>
        Offer financing as a premium part of your <em>client experience.</em>
      </h2>
      <p>
        Access the Home Design Guild member offer and activate your financing
        setup with Enhancify.
      </p>

      <div className="access-block">
        <div className="access-path">
          <h3 className="access-path-label">Already a Member?</h3>
          <p className="access-path-body">
            Log in and access your exclusive $1,500/year member pricing offer.
          </p>
          <AccessOfferLink className="access-btn access-btn-primary">
            Log In to Access
          </AccessOfferLink>
        </div>

        <div className="access-divider" aria-hidden="true">
          <span>or</span>
        </div>

        <div className="access-path">
          <h3 className="access-path-label">New to Home Design Guild?</h3>
          <p className="access-path-body">
            Create your free account first, then unlock the financing partner
            offer from your designer experience.
          </p>
          <Link to={Pages.SIGNUP} className="access-btn access-btn-secondary">
            Create Free Account
          </Link>
        </div>
      </div>

      <p className="bottom-cta-pricing">
        Member pricing: <strong>$1,500/year</strong> (regular $1,749)
      </p>

      <p className="bottom-cta-contact">
        Prefer direct access? Visit{" "}
        <a href={ENHANCIFY_PROMO_URL} target="_blank" rel="noopener noreferrer" className="btn-secondary">
          the Enhancify partner page
        </a>
        .
      </p>
    </section>
  );
};
